// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"80d754e4","525":"dc5dde21","992":"0500e7a7"}[chunkId] + ".chunk.js";
};